import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "../store/index";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("../App.vue"),
  // },
  // Hank
  {
    path: "*",
    redirect: "/404",
  },
  // Hank dashboard
  {
    path: "/FrontPage",
    name: "frontPage",
    component: () => import("../views/index/FrontPage/frontPage.vue"),
    meta: {
      breadcrumb: [
        {
          name: "首頁",
        },
      ],
    },
  },
  // Hank 404
  {
    path: "/404",
    name: "404",
    component: () => import("../components/404/404.vue"),
    meta: {
      breadcrumb: [
        {
          name: "首頁",
        },
        {
          name: "404",
        },
      ],
    },
  },
  // Hank 999
  {
    path: "/999",
    name: "999",
    component: () => import("../components/404/404.vue"),
    meta: {
      breadcrumb: [
        {
          name: "首頁",
        },
        {
          name: "999",
        },
      ],
    },
  },

  // Hank 1-1 index
  {
    path: "/",
    name: "index",
    component: () => import("../views/index/index/index.vue"),
  },
  // Hank 1-1 步驟一
  {
    path: "/companyApplyAccountStep1",
    name: "companyApplyAccountStep1",
    component: () =>
      import(
        "../views/index/companyApplyAccountStep1/companyApplyAccountStep1.vue"
      ),
  },
  // Hank 1-1 步驟二
  {
    path: "/companyApplyAccountStep2",
    name: "companyApplyAccountStep2",
    component: () =>
      import(
        "../views/index/companyApplyAccountStep2/companyApplyAccountStep2.vue"
      ),
  },
  // Hank 1-1 忘記密碼
  {
    path: "/forgetPswd",
    name: "forgetPswd",
    component: () => import("../views/index/forgetPswd/forgetPswd.vue"),
  },
  // Hank 1-1 更改密碼
  {
    path: "/changePswd",
    name: "changePswd",
    component: () => import("../views/index/changePswd/changePswd.vue"),
  },
  //驗証登入同意書畫面
  {
    path: "/loginConSent",
    name: "loginConSent",
    component: () => import("../views/index/loginConSent/loginConSent.vue"),
  },
  //協議組織同意書
  {
    path: "/conSentTodo",
    name: "conSentTodo",
    component: () => import("../views/index/conSentTodo/conSentTodo.vue"),
  },
  // Lynn 1-2 廠商基本資料管理 > 帳號審核管理
  {
    path: "/accountCensorManagement",
    name: "accountCensorManagement",
    component: () =>
      import(
        "../views/companyProfile/accountCensorManagement/accountCensorManagement.vue"
      ),
    meta: {
      breadcrumb: [{ name: "廠商基本資料管理" }, { name: "帳號審核管理" }],
    },
  },
  // Lynn 1-2 廠商基本資料管理 > 帳號審核管理 > 審核帳號
  {
    path: "/censorAccount/:id",
    name: "censorAccount",
    component: () =>
      import("../views/companyProfile/censorAccount/censorAccount.vue"),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "帳號審核管理" },
        { name: "審核帳號" },
      ],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改
  {
    path: "/companyProfileManagement",
    name: "companyProfileManagement",
    component: () =>
      import(
        "../views/companyProfile/companyProfileManagement/companyProfileManagement.vue"
      ),
    meta: {
      breadcrumb: [{ name: "廠商基本資料管理" }, { name: "廠商基本資料修改" }],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改 > 人員管理
  {
    path: "/staffManagement/:s_id",
    name: "staffManagement",
    component: () =>
      import("../views/companyProfile/staffManagement/staffManagement.vue"),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "廠商基本資料修改" },
        { name: "人員管理" },
      ],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改 > 人員管理 > 新增員工
  {
    path: "/createStaff/:s_id",
    name: "createStaff",
    component: () =>
      import("../views/companyProfile/createStaff/createStaff.vue"),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "廠商基本資料修改" },
        { name: "人員管理" },
        { name: "新增員工" },
      ],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改 > 人員管理 > 修改明細
  {
    path: "/editStaffProfile/:s_id/:id",
    name: "editStaffProfile",
    component: () =>
      import("../views/companyProfile/editStaffProfile/editStaffProfile.vue"),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "廠商基本資料修改" },
        { name: "人員管理" },
        { name: "修改明細" },
      ],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改 > 修改
  {
    path: "/editCompanyProfile/:s_id",
    name: "editCompanyProfile",
    component: () =>
      import(
        "../views/companyProfile/editCompanyProfile/editCompanyProfile.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "廠商基本資料修改" },
        { name: "修改" },
      ],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改 > 修改 > 重設密碼
  {
    path: "/resetPswd/:s_id",
    name: "resetPswd",
    component: () =>
      import("../views/companyProfile/changePswd/changePswd.vue"),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "廠商基本資料修改" },
        { name: "修改" },
        { name: "重設密碼" },
      ],
    },
  },
  // Hank 1-3 廠商基本資料管理 > 廠商基本資料修改 > 施工負責人/安衛人員
  {
    path: "/safetyChargemen/:s_Id",
    name: "safetyChargemen",
    component: () =>
      import("../views/companyProfile/safetyChargemen/safetyChargemen.vue"),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "廠商基本資料修改" },
        { name: "施工負責人/安衛人員" },
      ],
    },
  },
  // Lynn 1-4 廠商基本資料管理 > 帳號審核歷史資料查詢
  {
    path: "/accountCensorHistory",
    name: "accountCensorHistory",
    component: () =>
      import(
        "../views/companyProfile/accountCensorHistory/accountCensorHistory.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "帳號審核歷史資料查詢" },
      ],
    },
  },
  // Lynn 1-4 廠商基本資料管理 > 帳號審核歷史資料查詢 > 明細
  {
    path: "/accountCensorHistoryDetails/:id",
    name: "accountCensorHistoryDetails",
    component: () =>
      import(
        "../views/companyProfile/accountCensorHistoryDetails/accountCensorHistoryDetails.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "廠商基本資料管理" },
        { name: "帳號審核歷史資料查詢" },
        { name: "明細" },
      ],
    },
  },
  // Hank 1-5 課程報名
  {
    path: "/applyCourse",
    name: "applyCourse",
    component: () => import("../views/applyCourse/applyCourse.vue"),
    meta: {
      breadcrumb: [{ name: "課程報名" }],
    },
  },
  // Hank 1-6 工程單管理 > 新工程申請
  {
    path: "/newProjectApplication",
    name: "newProjectApplication",
    component: () =>
      import(
        "../views/engineeringManagement/newProjectApplication/newProjectApplication.vue"
      ),
    meta: {
      breadcrumb: [{ name: "工程單管理" }, { name: "新工程申請" }],
    },
  },
  // Lynn 1-7 工程單管理 > 工程資料管理
  {
    path: "/engineeringDataManagement",
    name: "engineeringDataManagement",
    component: () =>
      import(
        "../views/engineeringManagement/engineeringDataManagement/engineeringDataManagement.vue"
      ),
    meta: {
      breadcrumb: [{ name: "工程單管理" }, { name: "工程資料管理" }],
    },
  },
  // Lynn 1-7 工程單管理 > 工程資料管理 > 工程明細
  {
    path: "/engineeringDetails/:prjNo",
    name: "engineeringDetails",
    component: () =>
      import(
        "../views/engineeringManagement/engineeringDetails/engineeringDetails.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "工程單管理" },
        { name: "工程資料管理" },
        { name: "工程明細" },
      ],
    },
  },
  // Hank 1-7 工程單管理 > 工程資料管理 > 修改
  {
    path: "/engineeringDataManagementEdit/:prjNo/:id",
    name: "engineeringDataManagementEdit",
    component: () =>
      import(
        "../views/engineeringManagement/engineeringDataManagementEdit/engineeringDataManagementEdit.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "工程單管理" },
        { name: "工程資料管理" },
        { name: "修改" },
      ],
    },
  },
  // Lynn 1-7 工程資料管理 / 檢視簽核明細 [另開新頁]
  {
    path: "/viewSignOffDetails",
    name: "viewSignOffDetails",
    component: () =>
      import(
        "../views/engineeringManagement/viewSignOffDetails/viewSignOffDetails.vue"
      ),
  },
  // Lynn 1-8 工程單管理 > 工程單已簽核文件
  {
    path: "/signedDocument",
    name: "signedDocument",
    component: () =>
      import(
        "../views/engineeringManagement/signedDocument/signedDocument.vue"
      ),
    meta: {
      breadcrumb: [{ name: "工程單管理" }, { name: "工程單已簽核文件" }],
    },
  },

  // Lynn 2-1 緊急搶修單管理 > 緊急搶修單申請
  {
    path: "/emergencyRepairOrderApply",
    name: "emergencyRepairOrderApply",
    component: () => import("../views/emergencyRepairOrder/apply/apply.vue"),
    meta: {
      breadcrumb: [{ name: "緊急搶修單管理" }, { name: "緊急搶修單申請" }],
    },
  },
  // Hank 2-2 緊急搶修單管理 > 緊急搶修單資料管理
  {
    path: "/emergencyRepairOrderDataManagement",
    name: "emergencyRepairOrderDataManagement",
    component: () =>
      import("../views/emergencyRepairOrder/dataManagement/dataManagement.vue"),
    meta: {
      breadcrumb: [{ name: "緊急搶修單管理" }, { name: "緊急搶修單資料管理" }],
    },
  },
  // Lynn 2-2 緊急搶修單管理 > 緊急搶修單 > 編輯草稿
  {
    path: "/emergencyRepairOrderEdit/:prjNo",
    name: "emergencyRepairOrderEdit",
    component: () => import("../views/emergencyRepairOrder/apply/apply.vue"),
    meta: {
      breadcrumb: [{ name: "緊急搶修單管理" }, { name: "緊急搶修單申請" }],
    },
  },
  // Hank 2-2 緊急搶修單管理 > 緊急搶修單資料管理 > 緊急搶修單明細
  {
    path: "/emergencyRepairOrderDetails/:prjNo",
    name: "emergencyRepairOrderDetails",
    component: () =>
      import("../views/emergencyRepairOrder/details/details.vue"),
    meta: {
      breadcrumb: [
        { name: "緊急搶修單管理" },
        { name: "緊急搶修單資料管理" },
        { name: "緊急搶修單明細" },
      ],
    },
  },
  // Hank 2-2 緊急搶修單管理 > 緊急搶修單資料管理 > 檢視簽核明細 [另開新頁]
  {
    path: "/emergencyRepairOrderViewSignOffDetails",
    name: "emergencyRepairOrderViewSignOffDetails",
    component: () =>
      import(
        "../views/emergencyRepairOrder/emergencyRepairOrderViewSignOffDetails/emergencyRepairOrderViewSignOffDetails.vue"
      ),
    meta: {
      newData: null,
    },
  },
  // Hank 2-3 緊急搶修單管理 > 緊急搶修單已簽核文件
  {
    path: "/emergencyRepairOrderSignedDocuments",
    name: "emergencyRepairOrderSignedDocuments",
    component: () =>
      import(
        "../views/emergencyRepairOrder/signedDocuments/signedDocuments.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "緊急搶修單管理" },
        { name: "緊急搶修單已簽核文件" },
      ],
    },
  },
  // Hank 2-3 緊急搶修單管理已簽核文件 / 檢視簽核明細 [另開新頁]
  {
    path: "/emergencyRepairOrderViewSighOffDetails",
    name: "emergencyRepairOrderViewSighOffDetails",
    component: () =>
      import(
        "../views/emergencyRepairOrder/viewSignOffDetails/viewSignOffDetails.vue"
      ),
  },
  // Hank 2-4 每日工作許可單管理 > 每日工作申請
  {
    path: "/dailyJobApplication",
    name: "dailyJobApplication",
    component: () =>
      import(
        "../views/dailyWorkPermitManagement/dailyJobApplication/dailyJobApplication.vue"
      ),
    meta: {
      breadcrumb: [{ name: "每日工作許可單管理" }, { name: "每日工作申請" }],
    },
  },
  // Hank 2-4 每日工作許可單管理 > 每日工作申請 > 申請
  {
    // /applyDailyJobPermit/:prjNo/:prjName/:sId/:workSpace/:beginDate/:endDate
    path: "/applyDailyJobPermit/:obj",
    name: "applyDailyJobPermit",
    component: () =>
      import(
        "../views/dailyWorkPermitManagement/applyDailyJobPermit/applyDailyJobPermit.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "每日工作許可單管理" },
        { name: "每日工作申請" },
        { name: "申請" },
      ],
    },
  },
  // Hank 2-4 每日工作許可單管理 > 每日工作申請 > 草稿
  {
    // /applyDailyJobPermit/:prjNo/:prjName/:sId/:workSpace/:beginDate/:endDate
    path: "/draftDailyJobPermit/:obj/:draft",
    name: "draftDailyJobPermit",
    component: () =>
      import(
        "../views/dailyWorkPermitManagement/applyDailyJobPermit/applyDailyJobPermit.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "每日工作許可單管理" },
        { name: "每日工作申請" },
        { name: "草稿" },
      ],
    },
  },
  // Hank 2-5 每日工作許可單管理 > 施工群組設定
  {
    path: "/constructionGroupSetting",
    name: "constructionGroupSetting",
    component: () =>
      import(
        "../views/dailyWorkPermitManagement/constructionGroupSetting/constructionGroupSetting.vue"
      ),
    meta: {
      breadcrumb: [{ name: "每日工作許可單管理" }, { name: "施工群組設定" }],
    },
  },
  // Hank 2-6 每日工作許可單管理 > 工單資料管理
  {
    path: "/workOrderDataManagement",
    name: "workOrderDataManagement",
    component: () =>
      import(
        "../views/dailyWorkPermitManagement/workOrderDataManagement/workOrderDataManagement.vue"
      ),
    meta: {
      breadcrumb: [{ name: "每日工作許可單管理" }, { name: "工單資料管理" }],
    },
  },
  // kaiyeu 每日工作許可單管理 > 每日施工單已簽核文件
  {
    path: "/dailySignedDocument",
    name: "dailySignedDocument",
    component: () =>
      import(
        "../views/dailyWorkPermitManagement/dailySignedDocument/dailySignedDocument.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "每日工作許可單管理" },
        { name: "每日施工單已簽核文件" },
      ],
    },
  },
  // Hank 2-6 每日工作許可單管理 / 檢視 [另開新頁]
  {
    path: "/engineeringDataManagementView/",
    name: "engineeringDataManagementView",
    component: () => import("../views/dailyWorkPermitManagement/view/view.vue"),
  },
  // Hank 2-6 每日工作許可單管理 / 列印 [另開新頁]
  {
    path: "/engineeringDataManagementPrint/:apply_Pk",
    name: "engineeringDataManagementPrint",
    component: () =>
      import("../views/dailyWorkPermitManagement/print/print.vue"),
  },
  // Hank 2-6 每日工作許可單管理 / 檢視簽核明細 [另開新頁]
  {
    path: "/engineeringDataManagementViewDetail/:apply_Pk",
    name: "engineeringDataManagementViewDetail",
    component: () =>
      import("../views/dailyWorkPermitManagement/viewDetail/viewDetail.vue"),
  },
  // Lynn 2-7 服務中心管理頁面 > 危害告知教育訓練管理 > 教室/課程/課表管理
  {
    path: "/courseInfoManagement",
    name: "courseInfoManagement",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/courseInfoManagement/courseInfoManagement.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "教室/課程/課表管理" },
      ],
    },
  },
  // Lynn 2-7 服務中心管理頁面 > 危害告知教育訓練管理 > 教室/課程/課表管理 > 主項修改
  {
    path: "/scheduleMainEdit",
    name: "scheduleMainEdit",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/scheduleMainEdit/scheduleMainEdit.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "教室/課程/課表管理" },
        { name: "主項修改" },
      ],
    },
  },
  // Lynn 2-7 服務中心管理頁面 > 危害告知教育訓練管理 > 教室/課程/課表管理 > 狀態修改
  {
    path: "/scheduleStatusEdit",
    name: "scheduleStatusEdit",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/scheduleStatusEdit/scheduleStatusEdit.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "教室/課程/課表管理" },
        { name: "狀態修改" },
      ],
    },
  },
  // Hank 2-8 服務中心管理頁面 > 危害告知教育訓練管理 > 上課資格管理
  {
    path: "/classQualificationManagement",
    name: "classQualificationManagement",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/classQualificationManagement/classQualificationManagement.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "上課資格管理" },
      ],
    },
  },
  // Hank 2-8 服務中心管理頁面 > 危害告知教育訓練管理 > 上課資格管理 > 審查資格
  {
    path: "/qualification/:schedule_no/:available_begin_date/:class_date",
    name: "qualification",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/qualification/qualification.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "上課資格管理" },
        { name: "審查資格" },
      ],
    },
  },
  // Hank 2-9 服務中心管理頁面 > 危害告知教育訓練管理 > 點名管理/上課資格管理
  {
    path: "/rollCallManagement",
    name: "rollCallManagement",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/rollCallManagement/rollCallManagement.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "點名管理/上課資格管理" },
      ],
    },
  },
  // Hank 2-9 服務中心管理頁面 > 危害告知教育訓練管理 > 點名管理/上課資格管理 > 點名
  {
    path: "/rollCall/:schedule_no/:available_begin_date/:class_date",
    name: "rollCall",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/rollCall/rollCall.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "點名管理/上課資格管理" },
        { name: "點名" },
      ],
    },
  },
  // Hank 2-9 服務中心管理頁面 > 危害告知教育訓練管理 > 點名管理/上課資格管理 > 製卡管理
  {
    path: "/cardMakeManagement/:schedule_no/:available_begin_date/:class_date",
    name: "cardMakeManagement",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/cardMakeManagement/cardMakeManagement.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "點名管理/上課資格管理" },
        { name: "製卡管理" },
      ],
    },
  },
  // Hank 2-9 服務中心管理頁面 > 危害告知教育訓練管理 > 點名管理/上課資格管理 > 列印點名簿
  {
    path: "/printRoll",
    name: "printRoll",
    component: () =>
      import(
        "../views/serviceCenterManagement/hazardNotifyTraining/printRoll/printRoll.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "危害告知教育訓練管理" },
        { name: "點名管理/上課資格管理" },
        { name: "列印點名簿" },
      ],
    },
  },
  // Lynn 2-10 服務中心管理頁面 > 承攬商識別證管理 > 異動申請審核
  {
    path: "/changeApplyCensor",
    name: "changeApplyCensor",
    component: () =>
      import(
        "../views/serviceCenterManagement/contractorIdCardManagement/changeApplyCensor/changeApplyCensor.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "服務中心管理頁面" },
        { name: "承攬商識別證管理" },
        { name: "異動申請審核" },
      ],
    },
  },
  // Lynn 2-11 服務中心管理頁面 > 黑名單
  {
    path: "/blacklist",
    name: "blacklist",
    component: () =>
      import("../views/serviceCenterManagement/blacklist/blacklist.vue"),
    meta: {
      breadcrumb: [{ name: "服務中心管理頁面" }, { name: "黑名單" }],
    },
  },
  // Lynn 2-12 承攬商保險專區 > 展延申請
  {
    path: "/extensionApply",
    name: "extensionApply",
    component: () =>
      import("../views/contractorInsurance/extensionApply/extensionApply.vue"),
    meta: {
      breadcrumb: [{ name: "承攬商保險專區" }, { name: "展延申請" }],
    },
  },
  // Lynn 2-13 承攬商保險專區 > 展延審核
  {
    path: "/extensionCensor",
    name: "extensionCensor",
    component: () =>
      import(
        "../views/contractorInsurance/extensionCensor/extensionCensor.vue"
      ),
    meta: {
      breadcrumb: [{ name: "承攬商保險專區" }, { name: "展延審核" }],
    },
  },
  // Lynn 2-14 個人資料同意書專區 > 同意書上傳
  {
    path: "/consentUpload",
    name: "consentUpload",
    component: () =>
      import("../views/personalInfoConsent/consentUpload/consentUpload.vue"),
    meta: {
      breadcrumb: [{ name: "個人資料同意書專區" }, { name: "同意書上傳" }],
    },
  },
  // Lynn 2-15 個人資料同意書專區 > 同意書審核
  {
    path: "/consentCensor",
    name: "consentCensor",
    component: () =>
      import("../views/personalInfoConsent/consentCensor/consentCensor.vue"),
    meta: {
      breadcrumb: [{ name: "個人資料同意書專區" }, { name: "同意書審核" }],
    },
  },
  // Lynn 2-16 協議組織專區 > 入退會申請
  {
    path: "/joinQuitApply",
    name: "joinQuitApply",
    component: () =>
      import("../views/protocolOrganization/joinQuitApply/joinQuitApply.vue"),
    meta: {
      breadcrumb: [{ name: "協議組織專區" }, { name: "入退會申請" }],
    },
  },
  // Lynn 2-17 協議組織專區 > 入退會申請審核
  {
    path: "/joinQuitCensor",
    name: "joinQuitCensor",
    component: () =>
      import("../views/protocolOrganization/joinQuitCensor/joinQuitCensor.vue"),
    meta: {
      breadcrumb: [{ name: "協議組織專區" }, { name: "入退會申請審核" }],
    },
  },
  // Hank 2-18 協議組織專區 > 各廠區協議組織入會名冊查詢
  {
    path: "/protocolOrgManagement",
    name: "protocolOrgManagement",
    component: () =>
      import(
        "../views/protocolOrganization/protocolOrgManagement/protocolOrgManagement.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "協議組織專區" },
        { name: "各廠區協議組織入會名冊查詢" },
      ],
    },
  },
  // Hank 2-18 協議組織專區 > 各廠區協議組織入會名冊查詢 > 修改
  {
    path: "/editProtocolOrg",
    name: "editProtocolOrg",
    component: () =>
      import(
        "../views/protocolOrganization/editProtocolOrg/editProtocolOrg.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "協議組織專區" },
        { name: "各廠區協議組織入會名冊查詢" },
        { name: "修改" },
      ],
    },
  },
  // Hank 2-18 協議組織專區 > 各廠區協議組織入會名冊查詢 > 管理會員
  {
    path: "/memberManagement",
    name: "memberManagement",
    component: () =>
      import(
        "../views/protocolOrganization/memberManagement/memberManagement.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "協議組織專區" },
        { name: "各廠區協議組織入會名冊查詢" },
        { name: "管理會員" },
      ],
    },
  },
  // Hank 2-18 協議組織專區 > 各廠區協議組織入會名冊查詢 > 管理會員 > 新增會員
  {
    path: "/createMember/:po_Id",
    name: "createMember",
    component: () =>
      import("../views/protocolOrganization/createMember/createMember.vue"),
    meta: {
      breadcrumb: [
        { name: "協議組織專區" },
        { name: "各廠區協議組織入會名冊查詢" },
        { name: "管理會員" },
        { name: "新增會員" },
      ],
    },
  },

  // Hank 3-1 待簽核文件
  {
    path: "/documentsSignedOff",
    name: "documentsSignedOff",
    component: () => import("../views/pendingFiles/pendingFiles.vue"),
    meta: {
      breadcrumb: [{ name: "待簽核文件" }],
    },
  },
  // Hank 3-1 待簽核文件 / 每日工作許可單管理 / 檢視簽核明細 [另開新頁]
  {
    path: "/pendingFileDailyDetail/:apply_Pk",
    name: "pendingFileDailyDetail",
    component: () => import("../views/pendingFiles/viewDetail/viewDetail.vue"),
  },
  // Hank 3-2 單據查詢
  {
    path: "/documentQuery",
    name: "documentQuery",
    component: () => import("../views/docSearch/docSearch.vue"),
    meta: {
      breadcrumb: [{ name: "單據查詢" }],
    },
  },
  // 特殊專案施工單 / 檢視簽核明細 [另開新頁]
  {
    path: "/viewSpecialSignOffDetails",
    name: "viewSpecialSignOffDetails",
    component: () =>
      import(
        "../views/specialProject/viewSignOffDetails/viewSpecialSignOffDetails.vue"
      ),
  },
  // 特殊專案施工單 / 列印 [另開新頁]
  {
    path: "/printSpecialSignOffDetails",
    name: "printSpecialSignOffDetails",
    component: () =>
      import(
        "../views/specialProject/specialProjectOrderViewSignOffDetails/printSpecialSignOffDetails.vue"
      ),
  },
  // Lynn 3-3 工安管理頁面 > 工作區域與簽核人員管理
  {
    path: "/workAreaSignoffStaff",
    name: "workAreaSignoffStaff",
    component: () =>
      import(
        "../views/workSafetyManagement/workAreaSignoffStaff/workAreaSignoffStaff.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "工安管理頁面" },
        { name: "工作區域與簽核人員管理" },
      ],
    },
  },
  // Lynn 3-4 工安管理頁面 > 非無塵室各區名稱及負責人管理
  {
    path: "/nonDustlessRoom",
    name: "nonDustlessRoom",
    component: () =>
      import(
        "../views/workSafetyManagement/nonDustlessRoom/nonDustlessRoom.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "工安管理頁面" },
        { name: "非無塵室各區名稱及負責人管理" },
      ],
    },
  },
  // Lynn 3-5 工安管理頁面 > 無塵室各區名稱及負責人管理
  {
    path: "/dustlessRoom",
    name: "dustlessRoom",
    component: () =>
      import("../views/workSafetyManagement/dustlessRoom/dustlessRoom.vue"),
    meta: {
      breadcrumb: [
        { name: "工安管理頁面" },
        { name: "無塵室各區名稱及負責人管理" },
      ],
    },
  },
  // Lynn 3-6 工安管理頁面 > 高風險工作種類管理
  {
    path: "/highriskWork",
    name: "highriskWork",
    component: () =>
      import("../views/workSafetyManagement/highriskWork/highriskWork.vue"),
    meta: {
      breadcrumb: [{ name: "工安管理頁面" }, { name: "高風險工作種類管理" }],
    },
  },
  // Hank 3-7 工安管理頁面 > 消防中斷申請作業查詢
  {
    path: "/fireBreakApplyJobQuery",
    name: "fireBreakApplyJobQuery",
    component: () =>
      import(
        "../views/workSafetyManagement/fireSuspendApply/fireSuspendApply.vue"
      ),
    meta: {
      breadcrumb: [{ name: "工安管理頁面" }, { name: "消防中斷申請作業查詢" }],
    },
  },
  // Hank 3-8~3-11 工安管理頁面 > 變更簽核管理 > 次區域與當站簽核異動
  {
    path: "/subAreaInQueueSignoff",
    name: "subAreaInQueueSignoff",
    component: () =>
      import(
        "../views/workSafetyManagement/subAreaInQueueSignoff/subAreaInQueueSignoff.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "工安管理頁面" },
        { name: "變更簽核管理" },
        { name: "次區域與當站簽核異動" },
      ],
    },
  },
  // Lynn 3-12 工安管理頁面 > 變更簽核管理 > 變更發包工程師
  {
    path: "/changeContractEngineer",
    name: "changeContractEngineer",
    component: () =>
      import(
        "../views/workSafetyManagement/contractEngineer/contractEngineer.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "工安管理頁面" },
        { name: "變更簽核管理" },
        { name: "變更發包工程師" },
      ],
    },
  },
  // Hank 3-13 施工管理平台
  {
    path: "/constructionManagementPlatform",
    name: "constructionManagementPlatform",
    component: () =>
      import(
        "../views/constructionManagementPlatform/constructionManagementPlatform/constructionManagementPlatform.vue"
      ),
    meta: {
      breadcrumb: [{ name: "施工管理平台" }],
    },
  },
  // Hank 3-13 施工統計表 > (廠區名稱)
  {
    path: "/constructionStatistics/:detail",
    name: "constructionStatistics",
    component: () =>
      import(
        "../views/constructionManagementPlatform/constructionStatistics/constructionStatistics.vue"
      ),
    meta: {
      breadcrumb: [{ name: "施工管理平台" }, { name: "FAB1" }],
    },
  },
  // Hank 3-13 施工統計表 > (廠區名稱) > 施工區域顯示
  {
    path: "/constructionArea/:params",
    name: "constructionArea",
    component: () =>
      import(
        "../views/constructionManagementPlatform/constructionArea/constructionArea.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "施工管理平台" },
        { name: "FAB1" },
        { name: "施工區域顯示" },
      ],
    },
  },
  // Hank 3-13 施工統計表 > (廠區名稱) > 今日施工紀錄
  {
    path: "/constructionRecords/:params",
    name: "constructionRecords",
    component: () =>
      import(
        "../views/constructionManagementPlatform/constructionRecords/constructionRecords.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "施工管理平台" },
        { name: "FAB1" },
        { name: "今日施工紀錄" },
      ],
    },
  },
  // Hank 3-13 施工統計表 > (廠區名稱) > 資料查詢
  {
    path: "/dataQuery/:params",
    name: "dataQuery",
    component: () =>
      import("../views/constructionManagementPlatform/dataQuery/dataQuery.vue"),
    meta: {
      breadcrumb: [
        { name: "施工管理平台" },
        { name: "FAB1" },
        { name: "資料查詢" },
      ],
    },
  },
  // Lynn 3-14 廠商證照管理 > 新增證照資料
  {
    path: "/addLicenseInformation",
    name: "addLicenseInformation",
    component: () =>
      import(
        "../views/VendorLicense/addLicenseInformation/addLicenseInformation.vue"
      ),
    meta: {
      breadcrumb: [{ name: "廠商證照管理" }, { name: "新增證照資料" }],
    },
  },
  // Lynn 3-15 廠商證照管理 > 證照資料庫查詢
  {
    path: "/licenseDatabaseQuery",
    name: "licenseDatabaseQuery",
    component: () =>
      import(
        "../views/VendorLicense/licenseDatabaseQuery/licenseDatabaseQuery.vue"
      ),
    meta: {
      breadcrumb: [{ name: "廠商證照管理" }, { name: "證照資料庫查詢" }],
    },
  },

  // Hank 4-1 承攬商罰單管理
  {
    path: "/contractorTicketManagement",
    name: "contractorTicketManagement",
    component: () =>
      import(
        "../views/FineMgmt/contractorTicketManagement/contractorTicketManagement.vue"
      ),
    meta: {
      breadcrumb: [{ name: "承攬商罰單管理" }],
    },
  },
  // Hank 4-1 承攬商罰單管理 > 罰單資訊
  {
    path: "/ticketInformation/:s_Id/:s_Name",
    name: "ticketInformation",
    component: () =>
      import("../views/FineMgmt/ticketInformation/ticketInformation.vue"),
    meta: {
      breadcrumb: [{ name: "承攬商罰單管理" }, { name: "罰單資訊" }],
    },
  },
  // Hank 4-1 承攬商罰單管理 > 罰單資訊 > 罰單明細
  {
    path: "/ticketDetails/:fine_Id",
    name: "ticketDetails",
    component: () =>
      import("../views/FineMgmt/ticketDetails/ticketDetails.vue"),
    meta: {
      breadcrumb: [
        { name: "承攬商罰單管理" },
        { name: "罰單資訊" },
        { name: "罰單明細" },
      ],
    },
  },
  // Hank 4-1 承攬商罰單管理 / 罰單資訊 / 列印 [另開新頁]
  {
    path: "/ticketInformationPrint/:fine_Id",
    name: "ticketInformationPrint",
    component: () =>
      import(
        "../views/FineMgmt/ticketInformationPrint/ticketInformationPrint.vue"
      ),
  },
  // Hank 4-2 權限管理頁面 > 權限管理
  {
    path: "/authManagement",
    name: "authManagement",
    component: () =>
      import("../views/roleManagePage/authManagement/authManagement.vue"),
    meta: {
      breadcrumb: [{ name: "權限管理頁面" }, { name: "權限管理" }],
    },
  },
  // Hank 4-2 權限管理頁面 > 節點設定
  {
    path: "/nodeSetting",
    name: "nodeSetting",
    component: () =>
      import("../views/roleManagePage/nodeSetting/nodeSetting.vue"),
    meta: {
      breadcrumb: [{ name: "權限管理頁面" }, { name: "節點設定" }],
    },
  },
  // Hank 4-2 權限管理頁面 > 功能群組設定
  {
    path: "/functionalGroupSetting",
    name: "functionalGroupSetting",
    component: () =>
      import(
        "../views/roleManagePage/functionalGroupSetting/functionalGroupSetting.vue"
      ),
    meta: {
      breadcrumb: [{ name: "權限管理頁面" }, { name: "功能群組設定" }],
    },
  },
  // ? 4-3 識別證異動申請
  {
    path: "/idCardApply",
    name: "idCardApply",
    component: () => import("../views/idCardApply/idCardApply.vue"),
    meta: {
      breadcrumb: [{ name: "識別證異動申請" }],
    },
  },
  // Rand 4-4 變更安衛與監工人員
  {
    path: "/changeSecuritySupervisors",
    name: "changeSecuritySupervisors",
    component: () =>
      import(
        "../views/changeSecuritySupervisors/changeSecuritySupervisors.vue"
      ),
    meta: {
      breadcrumb: [{ name: "變更安衛與監工人員" }],
    },
  },
  // Walter 4-4 變更安衛與監工人員
  {
    path: "/staffChange",
    name: "staffChange",
    component: () => import("../views/staffChange/staffChange.vue"),
    meta: {
      breadcrumb: [{ name: "變更安衛與監工人員" }],
    },
  },

  // Hank 5-3 公告資訊 > 新公告發布
  {
    path: "/newAnnouncementReleased",
    name: "newAnnouncementReleased",
    component: () =>
      import(
        "../views/announcementInformation/newAnnouncementReleased/newAnnouncementReleased.vue"
      ),
    meta: {
      breadcrumb: [{ name: "公告資訊" }, { name: "新公告發布" }],
    },
  },
  // Hank 5-3 公告資訊 > 新公告發布 > 修改公告
  {
    path: "/newAnnouncementReleasedEdit/",
    name: "newAnnouncementReleasedEdit",
    component: () =>
      import(
        "../views/announcementInformation/newAnnouncementReleasedEdit/newAnnouncementReleasedEdit.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "公告資訊" },
        { name: "新公告發布" },
        { name: "修改公告" },
      ],
    },
  },
  // Lynn 5-4 公告資訊 > 歷史公告區
  {
    path: "/historyAnnouncement",
    name: "historyAnnouncement",
    component: () =>
      import(
        "../views/announcementInformation/historyAnnouncement/historyAnnouncement.vue"
      ),
    meta: {
      breadcrumb: [{ name: "公告資訊" }, { name: "歷史公告區" }],
    },
  },
  // Lynn 5-4 公告資訊 > 歷史公告區 > 明細
  {
    path: "/historyAnnouncementDetail/:bbs_No",
    name: "historyAnnouncementDetail",
    component: () =>
      import(
        "../views/announcementInformation/historyAnnouncementDetail/historyAnnouncementDetail.vue"
      ),
    meta: {
      breadcrumb: [
        { name: "公告資訊" },
        { name: "歷史公告區" },
        { name: "明細" },
      ],
    },
  },
  // Hank 5-5 承攬商規範與文件專區 > 維護區
  {
    path: "/FileMgmt",
    name: "FileMgmt",
    component: () => import("../views/FileMgmt/FileMgmt/FileMgmt.vue"),
    meta: {
      breadcrumb: [{ name: "承攬商規範與文件專區" }, { name: "維護區" }],
    },
  },
  // Lynn 5-6 承攬商規範與文件專區 > 下載區
  {
    path: "/FileDL",
    name: "download",
    component: () => import("../views/FileMgmt/FileDL/FileDL.vue"),
    meta: {
      breadcrumb: [{ name: "承攬商規範與文件專區" }, { name: "下載區" }],
    },
  },
  // 5-5~5-6 承攬商規範與文件專區 > 維護區
  {
    path: "/FileMgmt",
    name: "maintain",
    component: () => import("../views/FileMgmt/FileMgmt/FileMgmt.vue"),
    meta: {
      breadcrumb: [{ name: "承攬商規範與文件專區" }, { name: "維護區" }],
    },
  },
  // 特殊專案申請區
  {
    path: "/specialProjectOrderApply",
    name: "specialProjectOrderApply",
    component: () => import("../views/specialProject/apply/apply.vue"),
    meta: {
      breadcrumb: [{ name: "特殊專案管理" }, { name: "特殊專案單申請" }],
    },
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

/**
 * 解決F5刷新API refresh token問題
 * to.name === index, 404, 999 不打API直接進入
 * Vuex.state.loginSidebar沒有資料才打sidebar API
 */
router.beforeEach(async (to, from, next) => {
  //let newUrl = new URL(window.location.href.replace(/#\//g, "?"));
  //console.log(newUrl);
  if (to.name === "index" || to.name === "404" || to.name === "999") {
    next();
  } else {
    const sidebar = Vuex.state.loginSidebar;
    Vuex.state.currentPage = 1;
    if (sidebar.length) {
      next();
    } else {
      if (localStorage.getItem("ah")) {
        await Vuex.dispatch("qrySideBar");
        next();
      } else {
        if (
          to.name === "forgetPswd" ||
          to.name === "loginConSent" ||
          to.name === "conSentTodo" ||
          to.name === "companyApplyAccountStep1" ||
          to.name === "companyApplyAccountStep2"
        ) {
          next();
          return;
        }
        if (to.name !== "index" && !self.redirectUrl) {
          self.redirectUrl = to.name;
        }
        next({ name: "index" });
      }
    }
  }
});
router.afterEach((to) => {
  if (self.redirectUrl && to.name === "frontPage") {
    router.replace({ name: self.redirectUrl });
    self.redirectUrl = null;
  }
});
export default router;
